module.exports = __webpack_public_path__ + "static/media/remove-player.svg.a69a6a67.png";